import Location from "shared/Location";

const LocationDisplay = ({ location, noDataMessage = "No Default Location", isDisabled }) => {
    const { street, city, state, zip, phone, email } = location || {};
    if (state && street && city && zip && phone && email) {
        return <Location location={location} />;
    }
    return (
        <div className={`Location ${isDisabled ? "" : "Location--error"}`}>
            <div className="Location__line">{noDataMessage}</div>
        </div>
    );
};

export default LocationDisplay;
